module.exports = __webpack_public_path__ + "static/media/squirrel.e9854603.svg";